import styled from "styled-components";

export const Button = styled.button`
  width: auto;
  border: 1px solid #8290a2;
  border-radius: 4px;
  color: #8290a2;
  background: #fff;
  font-size: 14;
  padding: 15px 13px 14px;
  font-weight: 400;
  text-align: center;
  transition: all 0.2s ease-in-out;
  display: inline;
  margin-right: 10px;
`;

export const MainContent = styled.div`
  padding: 0 0 0 20px;
`;

export const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export const HeaderTitle = styled.div`
  float: left;
  margin: 0 0 7px;
  font-family: "Raleway";
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`;

export const HeaderDetails = styled.div`
  padding-bottom: 10px;
  font-size: 14px;
  font-family: "Raleway";
  color: #8290a2;
  font-weight: 500;
  display: inline-block;
`;

export const UserName = styled.div`
  width: 100%;
  float: left;
  margin: 42px 0 20px;
  font-weight: 700;
  color: #39b54a;
  font-family: "Raleway";
  font-size: 24px;
  padding-bottom: 15px;
`;

export const MainSection = styled.div`
  border-bottom: 1px solid #8da3aa;
  height: 85px;
  clear: both;
`;

export const DownloadLink = styled.div`
  color: #337ab7;
  display: inline-block;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
export const Container = styled.div`
  color: #8290a2;
  label {
    font-weight: 500;
  }
  input[type="checkbox"],
  input[type="radio"] {
    margin: 4px 10px 0 0;
    margin-top: 1px\9;
    line-height: normal;
  }
`;

export const ProfileDetails = styled.div`
  padding: 40px 0;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  li {
    float: left;
    margin-right: 20px;
  }
  i {
    margin-right: 8px;
  }
`;

export const Sections = styled.div`
  margin-bottom: 40px;
`;
